import useGlobal from 'appHost/Globals';
import { useEffect } from 'react';

import { botClient, useSection, useTracker } from '@/hooks';
import { UserRole } from '@/types';

export const useHomeRules = () => {
  const { user } = useGlobal();
  const { setSection } = useSection();
  const tracker = useTracker();

  useEffect(() => {
    tracker.dispatchWithUserData('risk_management_home_viewed');
  }, []);

  const handleClickRegisterTrucker = () => {
    const isAdmin = user.data.typeDescription === UserRole.ADMIN;
    const section = isAdmin ? 'termsForm' : 'responsibleForm';

    tracker.dispatchWithUserData('risk_onboarding_home_access_clicked');
    setSection(section);
  };

  const handleClickTalkWithASpecialist = () => {
    // eslint-disable-next-line no-underscore-dangle
    botClient?.widget?._openChat?.();
    tracker.dispatchWithUserData('risk_onboarding_home_specialist_clicked');
  };

  return {
    handleClickRegisterTrucker,
    handleClickTalkWithASpecialist,
  };
};
